import React, {useEffect, useState} from 'react';
import Breadcrumbs from '../breadcrumbs';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {Trans} from 'react-i18next';
import subscriptionUtils from '../../../utils/subscriptionUtils';
import smbUtils from '../../../utils/smbUtils';
import UpgradeModal from '../../auth/UpgradeModal';
import {solutionUtils} from '../../../utils/solutionUtils';
import storeUtils from '../../../utils/storeUtils';

export default function PageHeader(props) {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const functionType = useSelector(
    state => state.components.auth.accountSummary.customer.functionType
  );
  const isUpgrade = useSelector(
    state => state.components.auth.accountSummary.customer.upgraded
  );
  const params = new URLSearchParams(window.location.search);
  const loaded = params.get('loaded');

  const {customerId} = smbUtils.customerInfo(auth);
  const isScpActivationAllowed = smbUtils.isScpActivationAllowed(auth);

  const checkIsUpgrade = () => {
    //false → need to upgrade
    if (!subscriptionUtils.isOwnerRole(auth) || smbUtils.isCnSite(auth)) {
      return true;
    }
    if (functionType === 'SKINCARE_PRO') {
      if (
        !isScpActivationAllowed ||
        subscriptionUtils.isEnterprise(auth) ||
        solutionUtils.isOnlySimulation(auth)
      ) {
        return true;
      }
      return subscriptionUtils.isSkincareVersionAbove2AndHd(auth);
    }
    return isUpgrade;
  };

  const getUpdateState = () => {
    if (props.path !== '/') {
      return false;
    }
    return (
      !checkIsUpgrade() &&
      !storeUtils.getIsHideUpdatedModalForAllVersions(customerId, 2)
    );
  };

  const [showUpgradeModal, setShowUpgradeModal] = useState(getUpdateState());

  useEffect(() => {
    if (subscriptionUtils.isOverdue(auth)) setShowUpgradeModal(false);
  }, [auth]);

  return (
    <div className="kt-subheader kt-grid__item" style={{marginTop: '10px'}}>
      <div className="kt-subheader__main">
        <h3 className="kt-subheader__title subheader__pad-title">
          {props.title}{' '}
        </h3>
        {!checkIsUpgrade() && props.path === '/' && (
          <button
            className="btn btn-danger btn-pill py-4"
            onClick={() => {
              setShowUpgradeModal(true);
            }}
          >
            <>
              <i className="fa fa-arrow-alt-circle-up" />
              <span style={{fontSize: '1.2rem'}}>
                <Trans i18nKey="c.l.header.update.available.button">
                  Update Available
                </Trans>
              </span>
            </>
          </button>
        )}
        {showUpgradeModal && !loaded && (
          <UpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} />
        )}
        <span className="kt-subheader__separator kt-hidden" />
        {props.path !== '/' && props.path !== '/partner' && (
          <div className="kt-subheader__breadcrumbs">
            <Link to="/" className="kt-subheader__breadcrumbs-home">
              <i className="flaticon2-shelter" />
            </Link>
            <Breadcrumbs {...props} />
          </div>
        )}
      </div>
    </div>
  );
}
